import React, { useCallback, useEffect } from 'react';
import styles from './success.module.scss';
import { useTranslation } from 'react-i18next';
import Button from '../../components/button';
import Socials from '../../components/socials';
import { getDocumentPdf } from '../../api/documentApi';
import fileDownload from 'js-file-download';
import { useNavigate, useParams } from 'react-router-dom';

const SuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { documentId } = useParams();

  const downloadPdf = useCallback(async () => {
    if (!documentId) return;
    const pdf = await getDocumentPdf(documentId);
    fileDownload(pdf, 'document.pdf');
  }, [documentId]);

  useEffect(() => {
    if (!documentId) {
      navigate('/failed');
    }
  }, [navigate, documentId]);

  return (
    <div className={styles.success}>
      <div className={styles.top}>
        <div>
          <strong className="title">{t('success')}</strong>
        </div>
      </div>

      <div className={styles.main}>
        <strong>{t('thank_you_for_sign')}</strong>
        <p>{t('press_button_to_download_document')}</p>

        <div className={styles.warning}>{t('download_link_available_72_hours')}</div>

        <div className={styles.buttons}>
          <Button disabled={!documentId} className="full-width" onClick={downloadPdf}>
            {t('download_document')}
          </Button>
          <Button
            className="full-width secondary"
            onClick={() => (window.location.href = 'https://stb.onelink.me/aOEl/n0hci33z')}
          >
            {t('go_to_stb_app')}
          </Button>
        </div>

        <div className={styles.socials}>{t('visit_us_online')}</div>
        <Socials />
      </div>
    </div>
  );
};

export default SuccessPage;
